// @flow
import * as React from 'react';

import type { Entitlements, Features } from '../../types';

const defaultCondition = () => false;

type propsType = {
    children: (props: Object) => React.Element<any>,
    condition: (featureFlags: Features, entitlementFlags: Entitlements) => ?boolean,
    entitlementFlags: Entitlements,
    featureFlags: Features,
    isValidChildren: boolean
};

const ConditionalFeature = ({
    children,
    condition = defaultCondition,
    isValidChildren,
    featureFlags,
    entitlementFlags,
    ...rest
}: propsType) => {
    const shouldRender = isValidChildren && condition(featureFlags, entitlementFlags);
    return shouldRender ? children(rest) : null;
};

// the next property is used in the ProductPageLayout component
ConditionalFeature.areaName = 'ConditionalFeature';
export default ConditionalFeature;



// WEBPACK FOOTER //
// ./src/core/components/conditional-feature/component.js